import ContestCard from "../components/ContestCard"
import { useParams } from "react-router-dom"

const ContestList = ({ contests, myTeams, onJoin, teamIdFromUrl }) => {
  
  const {id} = useParams()
  const matchId = id

  if (!contests.length) {
    return <p className="text-theme-text-sec p-4">No contests</p>
  }

  return (
    <div className="p-3">
      {contests.map(c => (
        <ContestCard
          key={c.id}
          contest={c}
          matchId={matchId}
          myTeams={myTeams}
          onJoin={onJoin}
          teamIdFromUrl={teamIdFromUrl}
        />
      ))}
    </div>
  )
}

export default ContestList